"use strict";

var questions = [{
  prompt: "",
  extraText: "Think of a current situation when you felt frustrated, " + "irritated or disappointed with another person’s behaviour. Complete " + "the following sentence: I’m feeling…  with… because ….",
  placeholder: "E.g. I’m feeling frustrated with Dan because he didn’t " + "complete the task I asked him to do on time.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "Think about the expectations that you had of the other " + "person’s behaviour. Complete the following sentence: He/she should " + "have or shouldn’t have… (what they did to upset you).",
  placeholder: "E.g. He should have been able to complete the task.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "We will now look at the situation from the other person’s " + "perspective. This can be tricky, but doing this will help you " + "understand the situation from their point of view, build empathy and " + "may lead to a win-win. Try to ignore all the reasons why you think " + "their behaviour was wrong, and instead have a guess about the " + "reasons why they feel their behaviour was justified. Write out your " + "response using the following sentence: Because of current pressures " + "on … such as …, he/she acted this way because … ",
  placeholder: "E.g. Because of current pressures on Dan, such as " + "competing projects and unexpected setbacks with these, he was not " + "able to complete the task because he was short on time and had to " + "prioritize other tasks.",
  type: "multirow",
  aggregated: true
}, {
  prompt: "",
  extraText: "It may be difficult to take a guess at the reasons why the " + "other person felt their behaviour was justified at the time. If you " + "can’t think of any reasons, think about a similar situation when you " + "might have been in the other person’s shoes. This is one of the best " + "ways to understand another person’s point of view and empathise with " + "their situation. Using the previous sentence write down the reasons " + "why you felt your behaviour was justified at the time. Because of " + "current pressures on [me] such as …, I acted this way because … ",
  placeholder: "E.g. Because of current pressures on me such as competing " + "deadlines and unexpected setbacks with these, I wasn’t able to " + "complete the task I was asked to do because I was short on time and " + "I had to prioritize other tasks.",
  type: "multirow",
  aggregated: true
}];

var analysis = function analysis(answers) {
  return {
    answer1: answers[0],
    answer2: answers[1],
    answer3: answers[2],
    answer4: answers[3]
  };
};

module.exports = {
  questions: questions,
  analysis: analysis
};